import PagesChildTemplate from "./PagesChildTemplate";
export default PagesChildTemplate;